<div class="notification" *ngIf="notification$ | async as notification"
     [attr.position]="notification?.position== null || notification?.position === 'none' ? null : notification?.position"
     [style.color]="notification?.color"
     [style.background-color]="notification?.backgroundColor"
     [style.animation-duration.ms]="notification?.duration ?? 5000"
     [ngStyle]="notification?.style?.wrapper ?? {}"
     role="status"
     aria-live="polite">
    <div class="title-icon">
        <app-svg *ngIf="notification?.icon != null"
                 [ngStyle]="notification?.style?.icon ?? {}"
                 [use]="notification.icon"></app-svg>
        <p class="title"
           [ngStyle]="notification?.style?.title ?? {}"
           *ngIf="notification?.title != null">{{ notification.title }}</p>
    </div>
    <p [ngStyle]="notification?.style?.text ?? {}"
       *ngIf="notification?.text != null">{{ notification.text }}</p>
</div>
